import { render, staticRenderFns } from "./auxiMaterial.vue?vue&type=template&id=5d23b4d4&scoped=true&"
import script from "./auxiMaterial.vue?vue&type=script&lang=js&"
export * from "./auxiMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d23b4d4",
  null
  
)

export default component.exports